import data from './canciones.json';

export const canciones = data;
export const categorias = [...new Set(data.flatMap(c => c.categorias))].sort();
